var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-empty',{staticClass:"custom-image",attrs:{"image":"https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png","description":_vm.text || '暂无数据'}})
}
var staticRenderFns = []

export { render, staticRenderFns }